import { parseISO, differenceInSeconds, format } from 'date-fns'
import { t } from 'i18next'

function formatRelative (dateISO: string): string {
  const date = parseISO(dateISO)
  const now = Date.now()

  // TODO: handle future dates
  const diffInSeconds = differenceInSeconds(now, date)

  if (diffInSeconds < 0) {
    return format(date, 'dd/MM/yyyy')
  }

  if (diffInSeconds < 60) {
    return `${diffInSeconds} s`
  }

  const diffInMinutes = Math.round(diffInSeconds / 60)
  if (diffInMinutes < 60) {
    return `${diffInMinutes} m`
  }

  const diffInHours = Math.floor(diffInMinutes / 60)
  if (diffInHours < 24) {
    return `${diffInHours} h`
  }

  const diffInDays = Math.floor(diffInHours / 24)
  if (diffInDays < 7) {
    return t('TIME:DAY', { count: diffInDays })
  }

  const diffInWeeks = Math.floor(diffInDays / 7)
  if (diffInWeeks < 4) {
    return t('TIME:WEEK', { count: diffInWeeks })
  }

  const diffInMonths = Math.floor(diffInDays / 30)
  if (diffInMonths === 0) {
    return t('TIME:MONTH', { count: 1 })
  } else if (diffInMonths < 12) {
    return t('TIME:MONTH', { count: diffInMonths })
  }

  return format(date, 'dd/MM/yyyy')
}

export const dateUtils = { formatRelative }
